import { defineMessages } from 'react-intl';

export const saveArtefactMessages = defineMessages({
  savedTitle: {
    defaultMessage: 'Saved to Library',
    id: 'booQPaAAmF',
    description: 'Toast title after saving a Work export as a library artefact',
  },
  savedDescription: {
    defaultMessage: 'Find it in the artifacts section of your library.',
    id: 'Aes+p6STgy',
    description: 'Toast body after saving a Work export as a library artifact',
  },
  errorTitle: {
    defaultMessage: 'Could not save artifact',
    id: 'G4T25P7BH7',
    description: 'Toast title when saving a Work export to Library fails',
  },
  errorDescription: {
    defaultMessage: 'Please try again.',
    id: 'V2W3igcKKl',
    description: 'Generic toast body when saving a Work export to Library fails',
  },
  buttonLabel: {
    defaultMessage: 'Save as artifact',
    id: '857+n2ht7O',
    description: 'Button to save a Work export to Library artifacts',
  },
});
